import {Column, Entity, PrimaryColumn} from "typeorm"

@Entity()
export class RouterFeatureAvailability {

	@PrimaryColumn({unique: true})
	user!: string

	@Column()
	routerPanel!: boolean

	@Column()
	sectionGeneral!: boolean

	@Column()
	sectionPortForward!: boolean
	
	@Column()
	sectionPortForwardPreset!: boolean

	@Column()
	sectionWifi!: boolean

	@Column()
	sectionICMP!: boolean

	@Column()
	sectionARP!: boolean

	@Column()
	sectionDigitalIO!: boolean

	@Column()
	sectionSignalStrength!: boolean
}